<template>
    <div class="card">
        <div class="card-header">Automatische Bepreisung</div>
        <div class="card-body">
            <label>
                <span>Basiswert:</span>
                <select v-model="referenceValue" class="form-control">
                    <option
                        v-for="(option, index) in referenceValueOptions"
                        :key="index"
                        :value="option.name"
                        :selected="index === 0"
                    >
                        {{ option.text }}
                    </option>
                </select>
            </label>
            <label>
                <span>Abweichung (in %):</span>
                <b-form-input
                    id="difference"
                    v-model="difference"
                    type="text"
                    placeholder="Abweichung in Prozent"
                />
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: "Autobepreisung",
    data: function() {
        return {
            referenceValueOptions: [
                {
                    text: "Empf. VK",
                    value: "object:20",
                    name: "recommendedSellingPrice"
                },
                {
                    text: "Alter VK",
                    value: "object:21",
                    name: "sellingPricePharmacy"
                },
                {
                    text: "Durchschnitt Markt",
                    value: "object:22",
                    name: "averageMarketPrice"
                },
                {
                    text: "Min Markt",
                    value: "object:23",
                    name: "minMarketPrice"
                },
                {
                    text: "Max Markt",
                    value: "object:24",
                    name: "maxMarketPrice"
                }
            ]
        };
    },
    computed: {
        referenceValue: {
            get() {
                return this.$store.state.pricingOptions.referenceValue;
            },
            set(value) {
                this.$store.commit("setReferenceValue", value);
            }
        },
        difference: {
            get() {
                return this.$store.state.pricingOptions.difference;
            },
            set(value) {
                this.$store.commit("setDifference", value);
            }
        }
    },
    created() {
        if (!this.referenceValue) {
            this.$store.commit("setReferenceValue", this.referenceValueOptions[0].name);
        }
    }
};
</script>

<style scoped>
.card-body > * {
    margin: 2px;
}
.card-body > label {
    margin-top: 8px;
    margin-bottom: 0px;
}
</style>
